import { Text } from '@components/primitives/Text'

export default function TreatmentActionProperties({
  drugMechanismOfActionSummary,
  drugName,
}: {
  drugMechanismOfActionSummary: string | null
  drugName: string
}) {
  if (!drugMechanismOfActionSummary) {
    return null
  }
  return (
    <div className='my-8'>
      <Text
        className='my-4'
        styleName={'h4'}
        value={`How ${drugName} works in the body`}
      />
      <Text
        className='my-4'
        styleName={'p'}
        value={drugMechanismOfActionSummary}
      />
    </div>
  )
}
